import '@popperjs/core/dist/esm/popper.js';
import { Popover } from 'bootstrap/dist/js/bootstrap.js';
import 'anchor-js/anchor.min.js';
import 'is_js/is.js';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/fontawesome';
import 'lodash/lodash.min.js';
import 'list.js/dist/list.min.js';
import 'feather-icons/dist/feather.min.js';
import 'dayjs/dayjs.min.js';

// Bootstrap popovers (e.g. contextual help icons on config forms) must be
// initialized manually, and re-initialized after each Turbo Drive visit.
// They use the "focus" trigger so they open on click and close when the
// user clicks/tabs away, since they require a tabindex to be focusable.
//
// This lives here (not in application.js) so Bootstrap's JS is only ever
// evaluated once for the page. Importing `bootstrap` a second time from a
// separate Vite entrypoint would load a second, independent copy of every
// Bootstrap component -- including Collapse, which self-registers its own
// document-level click listener as a side effect of module evaluation.
// Two such listeners on the same page each track their own Collapse
// instance for the same DOM element, so a single click toggles both
// independently, racing each other (visible as a collapse starting to
// close and then immediately snapping back open).
document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    // Guard each element individually: a single popover failing to
    // initialize (e.g. due to unexpected markup) must not abort the
    // forEach loop and leave every later popover on the page uninitialized.
    try {
      Popover.getOrCreateInstance(el);
    } catch (error) {
      console.error('Failed to initialize popover', el, error);
    }
  });
});

document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    try {
      Popover.getInstance(el)?.dispose();
    } catch (error) {
      console.error('Failed to dispose popover', el, error);
    }
  });
});
